import { tv } from 'tailwind-variants';

export const TagVariants = tv({
  base: 'rounded-md bg-card-color-default px-3 py-1 text-sm font-medium',
  variants: {
    color: {
      default: 'text-color-medium',
      interdisciplinar:
        '!text-disciplina-interdisciplinar transition ease-in-out delay-100 ',
      redacao: '!text-disciplina-redacao transition ease-in-out delay-100 ',
      literatura:
        '!text-disciplina-literatura transition ease-in-out delay-100 ',
      espanhol: '!text-disciplina-espanhol transition ease-in-out delay-100 ',
      ingles: '!text-disciplina-ingles transition ease-in-out delay-100 ',
      portugues: '!text-disciplina-portugues transition ease-in-out delay-100 ',
      gramatica: '!text-disciplina-portugues transition ease-in-out delay-100 ',
      sociologia:
        '!text-disciplina-sociologia transition ease-in-out delay-100 ',
      filosofia: '!text-disciplina-filosofia transition ease-in-out delay-100 ',
      geografia: '!text-disciplina-geografia transition ease-in-out delay-100 ',
      historia: '!text-disciplina-historia transition ease-in-out delay-100 ',
      matematica:
        '!text-disciplina-matematica transition ease-in-out delay-100 ',
      fisica: '!text-disciplina-fisica transition ease-in-out delay-100 ',
      quimica: '!text-disciplina-quimica transition ease-in-out delay-100 ',
      biologia: '!text-disciplina-biologia transition ease-in-out delay-100 ',
      atualidades:
        '!text-disciplina-atualidades transition ease-in-out delay-100 ',
      'bioquimica-superior':
        '!text-disciplina-bioquimica-superior transition ease-in-out delay-100 ',
      'anatomia-superior':
        '!text-disciplina-anatomia-humana-superior transition ease-in-out delay-100 ',
      'histologia-humana-superior':
        '!text-disciplina-histologia-humana-superior transition ease-in-out delay-100 ',
      'fisiologia-superior':
        '!text-disciplina-fisiologia-humana-superior transition ease-in-out delay-100 ',
      'genetica-superior':
        '!text-disciplina-genetica-superior transition ease-in-out delay-100 ',
      'embriologia-superior':
        '!text-disciplina-embriologia-superior transition ease-in-out delay-100 ',
      'imunologia-superior':
        '!text-disciplina-imunologia-superior transition ease-in-out delay-100 ',
      'microbiologia-superior':
        '!text-disciplina-microbiologia-superior transition ease-in-out delay-100 ',
      'parasitologia-superior':
        '!text-disciplina-parasitologia-superior transition ease-in-out delay-100 ',
      'patologia-superior':
        '!text-disciplina-patologia-superior transition ease-in-out delay-100 ',
      'farmacologia-superior':
        '!text-disciplina-farmacologia-superior transition ease-in-out delay-100 ',
    },
    disabled: {
      true: '!text-button-color-secondary-disabled',
      false: '',
    },
    type: {
      review: '',
      default: '',
    },
    hasVinculed: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    {
      hasVinculed: true,
      disabled: true,
      class: '!text-feedback-color-success-pure',
    },
    {
      hasVinculed: false,
      disabled: false,
      class: 'text-color-brand-primary',
    },
    {
      hasVinculed: true,
      disabled: false,
      class: 'text-feedback-color-success-pure',
    },
    {
      hasVinculed: false,
      disabled: true,
      class: 'text-color-medium',
    },
  ],
  defaultVariants: {
    disabled: false,
    hasVinculed: false,
  },
});
